import { z } from "zod";

export const articleCategorySchema = z.object({
	id: z.string().optional(),
	name: z.string(),
	description: z.string().optional().nullable(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
	label: z.string().optional(),
	value: z.string().optional(),
});

export type ArticleCategory = z.infer<typeof articleCategorySchema>;
